// Module-level singletons — shared across all component instances, same pattern as
// isDebugActive in useCAODeviationDebug.ts.
export var generalDebugInfo = ref(null);
/** SiteConfig toggle (EnableRemunerationDebugPanel) — gates CAOGeneralDebugPanel.vue independently of isDebugActive. */
export var showGeneralDebugPanel = ref(false);
/**
 * Reads the remuneration/CAO debug fields off a step's context and stores them for the
 * general debug panel, along with whether the SiteConfig toggle allows showing it at all.
 */
export function setGeneralDebugInfo(context) {
  var _context$UsedCAO;
  showGeneralDebugPanel.value = Boolean(context === null || context === void 0 ? void 0 : context.ShowRemunerationDebugPanel);
  var remuneration = context === null || context === void 0 ? void 0 : context.Remuneration;
  if (!remuneration) return;
  generalDebugInfo.value = {
    ID: remuneration.ID,
    Hash: remuneration.Hash,
    Version: remuneration.Version,
    PublishDate: remuneration.PublishDate,
    MigratedVersion: remuneration.MigratedVersion,
    MigratedAt: remuneration.MigratedAt,
    UsedCAO: (_context$UsedCAO = context === null || context === void 0 ? void 0 : context.UsedCAO) !== null && _context$UsedCAO !== void 0 ? _context$UsedCAO : null
  };
}
export function useRemunerationDebugInfo() {
  return {
    generalDebugInfo: generalDebugInfo,
    showGeneralDebugPanel: showGeneralDebugPanel
  };
}